import React from 'react'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Nav({ rulesets, setActiveRuleset, activeRuleset }) {
  return (
    <nav aria-label="Ruleset Tabs" className="-mb-px flex space-x-8">
      {rulesets.map((ruleset) => (
        <button
          key={ruleset.id}
          type="button"
          onClick={() => setActiveRuleset(ruleset)}
          className={classNames(
            activeRuleset.id === ruleset.id
              ? 'border-teal-500 text-teal-600'
              : 'border-transparent text-gray-500 hover:border-slate-300 hover:text-gray-700',
            'whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium focus:outline-none'
          )}
        >
          {ruleset.chain.name} - {ruleset.policy_type_display}
        </button>
      ))}
    </nav>
  )
}
